import './userProfile.css';
import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import ApiService from '../../services/apiService';
import { Popover, PopoverHeader, PopoverBody, Button } from 'reactstrap';
import GameHeader from '../header/header';

const UserProfile = () => {

    let navigate = useNavigate();
    const [userData, setItems] = useState([]);
    const apiService = new ApiService();
    const [popoverOpen, setPopoverOpen] = useState(false);
    const togglePopover = () => setPopoverOpen(!popoverOpen);
    const [copied, setCopied] = useState(false);
    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
            fetchuserData(items)
        }
    }, []);

    const fetchuserData = async (items) => {
        try {
            const params = new URLSearchParams();
            params.append('id', items?.nameid);
            const res = await apiService.getApiParamater('GET_GAME_USER', `?${params.toString()}`);
            setItems(res?.data[0]);
        } catch (error) {
            console.error("Error fetching Currency data:", error);
        }
    }

    const mapOrderType = (memberLevel) => {
        switch (memberLevel) {
            case 1:
                return "Standard";
            case 2:
                return "Elite";
            case 3:
                return "Expert";
            case 4:
                return "Master";
            default:
                return "Standard";
        }
    };
    return (
        <div className="obtibg">
            <GameHeader />
            <div className="profile-container">
                <div className="profile-card">
                    <div className="badge">{mapOrderType(userData?.memberLevel)}</div>
                    <div className="username">{userData?.username}</div>
                    {/* <div className="invitation">Invitation Code: <span>{userData?.invitationCode}</span></div> */}
                    <div className="invitation">
                        Invitation Code:
                        <span
                            id="inviteCode"
                            onClick={togglePopover}
                            style={{ cursor: 'pointer', color: '#00ff88', fontWeight: 'bold', marginLeft: '6px' }}
                        >
                            {userData?.invitationCode}
                        </span>
                    </div>

                    <Popover
                        placement="bottom"
                        isOpen={popoverOpen}
                        target="inviteCode"
                        toggle={togglePopover}
                        trigger="legacy"
                    >
                        <PopoverHeader>Copy Invitation Code</PopoverHeader>
                        <PopoverBody>
                            <div className='center'>
                                <Button
                                    size="sm"
                                    color="success"
                                    onClick={() => {
                                        navigator.clipboard.writeText(userData?.invitationCode);
                                        setCopied(true);
                                        setTimeout(() => {
                                            setCopied(false);
                                            setPopoverOpen(false);
                                        }, 1000);
                                    }}
                                >
                                    {copied ? "Copied!" : "Copy"}
                                </Button>
                            </div>
                        </PopoverBody>
                    </Popover>
                    <div className="progress-bar-container">
                        <div className="progress-bar">
                            <div className="progress-fill" style={{ width: `100 %` }}>
                                <span>100 %</span>
                            </div>
                        </div>
                    </div>

                    <div className="balance-section">
                        <div className="balance-card">
                            <div className="label">Account Balance (USDC)</div>
                            <div className="value green">${userData?.balance?.toFixed(2)}</div>
                        </div>
                        <div className="balance-card">
                            <div className="label">Commission (USDC)</div>
                            <div className="value green">${userData?.winningAmount?.toFixed(2)}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserProfile;
